module.exports = __webpack_public_path__ + "static/media/cortefiel@2x.571f405a.jpg";